import { Dialog } from "@material-ui/core";
import "./style.scss";

// Import Icons
import InfoIcon from "assets/icons/info.svg";
import { useState } from "react";
import { createMarket } from "utils/createMarket";
import { fetchUserAccounts } from "ts/accountInfo/tokens";
import state, { accounts } from "redux/state";
import { useDispatch, useSelector } from "react-redux";


const CreateMarketPopup = ({open, onClose}) => {

  const state = useSelector((state) => state.storage);
  const dispatch = useDispatch();
  const [baseMint, setBaseMint] = useState("");
  const [quoteMint, setQuoteMint] = useState("");

  const [minSize, setMinSize] = useState("");
  const [priceTick, setPriceTick] = useState("");

  return <Dialog
    classes={{ root: "popup_container", paper: "createMarketPopup" }}
    aria-labelledby="simple-dialog-title"
    open={open}
    onClose={onClose}
  >
    <p className="title">
      Create a new market
    </p>
    <p className="description">
      Configure the mint addresses for the tokens you want to create a market for
    </p>

    <div className="block">
      <p className="subheader">Token Information</p>
      <div className="inputContainer">
        <p className="label">Base Token Mint Address</p>
        <input placeholder="Address" value={baseMint} onChange={(e) => setBaseMint(e.target.value)}/>
      </div>
      <div className="inputContainer">
        <p className="label">Quote Token Mint Address</p>
        <input placeholder="Address" value={quoteMint} onChange={(e) => setQuoteMint(e.target.value)}/>
      </div>
    </div>
    
    
    <div className="block">
      <p className="subheader">Market Information</p>
      <div className="inputContainer">
        <p className="label">Minimum Order Size</p>
        <input placeholder="0.01" value={minSize} onChange={(e) => setMinSize(e.target.value)}/>
      </div>
      <div className="inputContainer">
        <p className="label">Price Tick</p>
        <input placeholder="0.001" value={priceTick} onChange={(e) => setPriceTick(e.target.value)}/>
      </div>
    </div>
    <div className="endBlock">
      <p className="fee">Fee: 3 SOL</p>
      <div className="createButton" onClick={() => {
        createMarket(state.connection, state.wallet, baseMint, quoteMint, minSize, priceTick)
          .catch(e => {
            return {message: e, marketAddress: "AAAAAA", success: false};
          })
          .then(res => {
            console.log(res);
            if (res && res.success) {
              fetchUserAccounts(state).then(result => dispatch(accounts(result)));
              document.location.href = "/?market="+res.marketAddress;
              onClose();
            }
          })
      }}>Create Market</div>
    </div>
    

  </Dialog>
}

export default CreateMarketPopup;

